export const featuredArticles = [
  {
    id: 1,
    slug: 'top-star-scandal-leak',
    title: '顶流男星深夜密会网红，酒店监控视频独家曝光',
    excerpt: '据知情人士透露，该顶流男星在某五星级酒店与神秘女子共度三小时，全程被监控拍下。女方疑似某短视频平台千万粉丝网红，两人此前多次在社交平台互动引发猜测。',
    category: '明星黑料',
    categorySlug: 'star-scandal',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20hotel%20corridor%20at%20night%20with%20dramatic%20lighting%20shadows%20and%20mysterious%20atmosphere%20cinematic%20photography%20style%20with%20warm%20amber%20tones%20and%20deep%20blacks%20luxury%20hotel%20interior%20with%20dim%20lights&width=800&height=500&seq=featured-article-01&orientation=landscape',
    publishedAt: '2026-07-07T14:30:00',
    views: 1285000,
    comments: 32567,
    isHot: true,
    isNew: false,
    tag: '独家',
  },
  {
    id: 2,
    slug: 'influencer-divorce-dark-secret',
    title: '知名网红夫妻离婚内幕：第三者竟是其经纪人，聊天记录全曝光',
    excerpt: '百万粉丝网红夫妇突然宣布离婚，背后真相令人震惊。据圈内人爆料，第三者竟是女方多年经纪人，两人秘密交往超过两年。大量暧昧聊天记录已在粉丝群流传。',
    category: '网红吃瓜',
    categorySlug: 'influencer-gossip',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20split%20composition%20showing%20a%20fractured%20relationship%20concept%20with%20warm%20moody%20lighting%20emotional%20atmosphere%20modern%20interior%20setting%20with%20shadows%20and%20contrast%20cinematic%20photography%20style&width=800&height=500&seq=featured-article-02&orientation=landscape',
    publishedAt: '2026-07-07T10:15:00',
    views: 986000,
    comments: 21890,
    isHot: true,
    isNew: true,
    tag: '热瓜',
  },
  {
    id: 3,
    slug: 'talent-show-rigging-exposed',
    title: '选秀节目黑幕大揭底：导师私下收取巨额贿赂操控比赛结果',
    excerpt: '某热播选秀节目被曝存在严重黑幕操作，多位参赛选手联合实名举报。据称导师团队收受选手经纪公司贿赂，提前内定前三名。节目组已启动内部调查。',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20performance%20scene%20with%20spotlight%20and%20dark%20shadows%20mysterious%20atmosphere%20behind%20the%20scenes%20talent%20show%20setting%20with%20dramatic%20contrast%20lighting%20cinematic%20style&width=800&height=500&seq=featured-article-03&orientation=landscape',
    publishedAt: '2026-07-06T22:00:00',
    views: 756000,
    comments: 15432,
    isHot: false,
    isNew: true,
    tag: '独家',
  },
  {
    id: 4,
    slug: 'live-streamer-tax-evasion',
    title: '头部主播涉嫌偷税漏税被调查，金额高达数千万',
    excerpt: '税务部门对某头部直播带货主播展开调查，初步查明其通过虚假合同、阴阳账本等手段偷逃税款。该主播年收入超亿元，此次涉案金额令人咋舌。',
    category: '明星黑料',
    categorySlug: 'star-scandal',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20modern%20office%20interior%20with%20dramatic%20lighting%20and%20shadows%20serious%20atmosphere%20with%20documents%20on%20desk%20cinematic%20photography%20style%20dark%20moody%20tones%20professional%20setting&width=800&height=500&seq=featured-article-04&orientation=landscape',
    publishedAt: '2026-07-06T18:45:00',
    views: 643000,
    comments: 12890,
    isHot: false,
    isNew: false,
    tag: '追踪',
  },
];

export const dailyContestArticles = [
  {
    id: 5,
    slug: 'daily-contest-celebrity-feud',
    title: '两大花旦公开互撕！微博评论区炸了，工作室紧急发声明',
    excerpt: '娱乐圈两大一线女星因新剧番位问题在社交平台公开互呛，双方粉丝已经开战超过24小时，话题阅读量破10亿。',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20confrontation%20scene%20with%20two%20silhouettes%20facing%20each%20other%20under%20spotlight%20stage%20setting%20with%20intense%20atmosphere%20cinematic%20lighting%20warm%20and%20cool%20tone%20contrast&width=600&height=450&seq=daily-01&orientation=landscape',
    publishedAt: '2026-07-07T08:00:00',
    views: 890000,
    comments: 45678,
    isHot: true,
  },
  {
    id: 6,
    slug: 'daily-contest-idol-dating',
    title: '偶像团体成员深夜约会素人，粉丝脱粉回踩曝更多猛料',
    excerpt: '某当红偶像团体成员被拍到与素人女子深夜约会，举止亲密。粉丝后援会宣布集体脱粉，并爆料该偶像此前多次违反恋爱禁令。',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    image: 'https://readdy.ai/api/search-image?query=Night%20street%20scene%20with%20neon%20lights%20and%20romantic%20atmosphere%20couple%20silhouette%20in%20the%20distance%20urban%20cityscape%20at%20night%20cinematic%20photography%20style%20with%20bokeh%20lights&width=600&height=450&seq=daily-02&orientation=landscape',
    publishedAt: '2026-07-07T06:30:00',
    views: 720000,
    comments: 28900,
    isHot: true,
  },
  {
    id: 7,
    slug: 'daily-contest-variety-show-drama',
    title: '综艺节目录制现场爆发冲突，嘉宾当场离席拒绝录制',
    excerpt: '某热门综艺最新一期录制过程中，两位嘉宾因游戏环节产生争执，其中一位直接摔话筒离场。节目组已紧急暂停录制。',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    image: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20tension%20atmosphere%20bright%20stage%20lights%20and%20dark%20shadows%20confrontation%20scene%20cinematic%20photography%20style%20professional%20broadcast%20setting&width=600&height=450&seq=daily-03&orientation=landscape',
    publishedAt: '2026-07-06T20:00:00',
    views: 567000,
    comments: 19800,
    isHot: false,
  },
  {
    id: 8,
    slug: 'daily-contest-actress-pregnancy',
    title: '当红女星疑似怀孕？宽松衣着现身机场，工作人员全程护驾',
    excerpt: '近日有网友拍到某当红女星现身机场，全程身穿宽松连衣裙，多名工作人员贴身保护。其与圈外男友已交往两年，婚讯传闻已久。',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    image: 'https://readdy.ai/api/search-image?query=Airport%20terminal%20scene%20with%20soft%20natural%20lighting%20busy%20travel%20atmosphere%20people%20walking%20in%20distance%20modern%20architecture%20cinematic%20style%20photography&width=600&height=450&seq=daily-04&orientation=landscape',
    publishedAt: '2026-07-06T16:00:00',
    views: 445000,
    comments: 15600,
    isHot: false,
  },
];

export const realtimeTracking = [
  {
    id: 1,
    title: '直播翻车现场',
    description: '主播带货翻车合集，假货、价格欺诈、虚假宣传实时追踪',
    icon: 'ri-live-line',
    slug: 'live-stream-fail',
    count: 128,
  },
  {
    id: 2,
    title: '恋情实锤曝光',
    description: '明星网红恋情实锤持续跟新，高清同框照片视频不容错过',
    icon: 'ri-heart-pulse-line',
    slug: 'romance-exposed',
    count: 96,
  },
  {
    id: 3,
    title: '合同纠纷内幕',
    description: '艺人经纪合同纠纷、解约官司内幕追踪，独家文件流出',
    icon: 'ri-file-paper-2-line',
    slug: 'contract-dispute',
    count: 73,
  },
  {
    id: 4,
    title: '人设崩塌记录',
    description: '明星网红人设崩塌全记录，从学霸到渣男，真相只有一个',
    icon: 'ri-emotion-sad-line',
    slug: 'persona-collapse',
    count: 156,
  },
  {
    id: 5,
    title: '综艺剧本泄密',
    description: '各大综艺节目剧本提前泄露，幕后操控手段大揭秘',
    icon: 'ri-file-text-line',
    slug: 'script-leak',
    count: 42,
  },
  {
    id: 6,
    title: '品牌代言翻车',
    description: '明星代言品牌争议事件汇总，消费者权益受损案例追踪',
    icon: 'ri-advertisement-line',
    slug: 'endorsement-fail',
    count: 89,
  },
];

export const categoryList = [
  { name: '明星黑料', slug: 'star-scandal', icon: 'ri-star-line', count: 2340, color: 'bg-primary-500' },
  { name: '网红吃瓜', slug: 'influencer-gossip', icon: 'ri-user-smile-line', count: 1890, color: 'bg-accent-500' },
  { name: '每日大赛', slug: 'daily-contest', icon: 'ri-fire-line', count: 1560, color: 'bg-primary-500' },
  { name: '视频爆料', slug: 'video-leak', icon: 'ri-vidicon-line', count: 980, color: 'bg-secondary-500' },
  { name: '直播翻车', slug: 'live-stream-fail', icon: 'ri-live-line', count: 720, color: 'bg-accent-500' },
  { name: '恋情曝光', slug: 'romance-exposed', icon: 'ri-heart-pulse-line', count: 650, color: 'bg-primary-500' },
];

export const testimonials = [
  {
    id: 1,
    content: '51爆料真的太及时了！每次有大瓜我都是第一个在这里看到的，比其他平台快了至少半天。吃瓜就认准51爆料！',
    author: '吃瓜一线猹',
    role: '资深吃瓜群众 · 3年老用户',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20person%20portrait%20with%20modern%20casual%20style%20neutral%20expression%20clean%20background%20headshot%20photography&width=120&height=120&seq=avatar-01&orientation=squarish',
  },
  {
    id: 2,
    content: '之前在其他平台看到的爆料都是二手消息，51爆料是真的有一手线人。上次那个顶流塌房事件，51提前三天就发了预警。',
    author: '娱乐圈纪检委',
    role: '娱乐博主 · 2年老用户',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20looking%20Chinese%20person%20portrait%20with%20stylish%20appearance%20confident%20expression%20clean%20studio%20background%20headshot&width=120&height=120&seq=avatar-02&orientation=squarish',
  },
  {
    id: 3,
    content: '每天上班第一件事就是打开51爆料看看今天有什么新瓜，已经成为日常习惯了。内容质量很高，不是那种标题党。',
    author: '摸鱼小能手',
    role: '忠实用户 · 1年老用户',
    avatar: 'https://readdy.ai/api/search-image?query=Casual%20young%20Chinese%20person%20portrait%20with%20friendly%20smile%20relaxed%20expression%20clean%20simple%20background%20headshot%20photography&width=120&height=120&seq=avatar-03&orientation=squarish',
  },
];

export const siteStats = {
  totalArticles: 12580,
  dailyVisitors: 3500000,
  registeredUsers: 2800000,
  totalComments: 89000000,
};